const TAB_ALL = 'all'
const TAB_USER = 'user'
const TAB_TRIGGER = 'trigger'
const TAB_SYSTEM = 'system'

const TABS = [TAB_ALL, TAB_USER, TAB_TRIGGER, TAB_SYSTEM]
const KEY = 'actor'

function read(query = {}) {
  const value = query[KEY]
  if (typeof value === 'string' && TABS.includes(value)) return value
  return TAB_ALL
}

/**
 * Missing / empty `actor` means All (valid — keep URL clean).
 * Only rewrite when the value is present but invalid.
 */
function hasTab(query = {}) {
  if (!Object.prototype.hasOwnProperty.call(query, KEY)) return true
  const value = query[KEY]
  if (value === '' || value == null) return true
  return typeof value === 'string' && TABS.includes(value)
}

function withTab(query = {}, active = TAB_ALL) {
  const next = { ...query }
  if (active === TAB_ALL) {
    delete next[KEY]
    return next
  }
  next[KEY] = active
  return next
}

class TicketActorTabUtility {
  TAB_ALL = TAB_ALL
  TAB_USER = TAB_USER
  TAB_TRIGGER = TAB_TRIGGER
  TAB_SYSTEM = TAB_SYSTEM
  TABS = TABS

  read(query) {
    return read(query)
  }

  hasTab(query) {
    return hasTab(query)
  }

  withTab(query, active) {
    return withTab(query, active)
  }
}

export default new TicketActorTabUtility()
